export const environment = {
  production: true,
  apiUrl: 'https://newcustomersnode.sagenorthamerica.com',
  captchaSiteKey:'6LfaP3MrAAAAAPl08_YNUPZFQI5fedid2OVEIJkw',
  paymetricUrl: `https://xiecomm.worldpay.com/diecomm/Processing/XiSecure.ashx`,
  portalUrl: 'https://partners.sagenorthamerica.com'
};
